import { ThunkType } from "../../../../core/store/reducers";
import { getMarginsExcel } from "../api/getMarginsExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../marginsDataSlice";

export const downloadMarginsExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.marginsData;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getMarginsExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "Margins.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
